<template>
   <pb-body-base>
      <template v-slot:default="props">
         <pb-body class="mx-2">
            <template slot="title">
               <b-container>
                  <b-row class="mt-5 mb-2">
                  </b-row>
               </b-container>
            </template>
            <template slot="body">
               <b-card no-body>
                  <b-card-header header-tag="nav">
                     <b-nav class="card-header-tabs" card-header tabs align="center">
                        <b-nav-item to="orders" active-class="active">Orders
                        </b-nav-item>
<!--                        <b-nav-item to="pricing"
                                    active-class="active">Pricing
                        </b-nav-item>
                        <b-nav-item to="article"
                                    active-class="active">Articles
                        </b-nav-item>-->
                     </b-nav>
                  </b-card-header>
                  <b-card-body class="text-left">
                     <router-view></router-view>
                  </b-card-body>
               </b-card>
            </template>
         </pb-body>
      </template>
   </pb-body-base>
</template>

<script>

export default {
   name: 'Supplier'
}
</script>